import React from "react";
import PropTypes from "prop-types";
import queryString from "query-string";

import { getPdfLink } from "../utils/api";
import FilterBox from "./FilterBox";
import MapContainer from "../containers/MapContainer";

class MainWrapper extends React.Component {
  render() {
    const {
      institutions,
      activeInstitution,
      onSetActiveInstitution,
      onSetFilters,
      categories,
      districts,
      districtsFilter,
      categoriesFilter,
      freetextFilter,
      offbordersFilter,
      isLoadingCategories,
      isFetchingInstitutions
    } = this.props;

    const pdfLink = getPdfLink(location.search);

    return (
      <div className="flex-1-1 flex-row flex-nowrap mobile-column overflow-scroll">
        <FilterBox
          onSetFilters={onSetFilters}
          districtsFilter={districtsFilter}
          categoriesFilter={categoriesFilter}
          freetextFilter={freetextFilter}
          offbordersFilter={offbordersFilter}
          pdfLink={pdfLink}
          onSetActiveInstitution={onSetActiveInstitution}
          institutions={institutions}
          activeInstitution={activeInstitution}
          categories={categories}
          districts={districts}
          isLoadingCategories={isLoadingCategories}
          isFetchingInstitutions={isFetchingInstitutions}
          className="flex-1-1 mobile-no-grow"
        />
        <MapContainer className="flex-3-3" />
      </div>
    );
  }
}

MainWrapper.propTypes = {
  institutions: PropTypes.array,
  activeInstitution: PropTypes.string,
  onSetActiveInstitution: PropTypes.func,
  onSetFilters: PropTypes.func,
  categories: PropTypes.array,
  districts: PropTypes.array,
  districtsFilter: PropTypes.array,
  categoriesFilter: PropTypes.array,
  freetextFilter: PropTypes.string,
  isLoadingCategories: PropTypes.bool,
  isFetchingInstitutions: PropTypes.bool
};

export default MainWrapper;



/** WEBPACK FOOTER **
 ** ./src/components/MainWrapper.jsx
 **/